export default __webpack_public_path__ + "static/media/Pandu.2efc179c.png";